exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-address {\n  width: 100%;\n}\n.shipping-address .vti__dropdown {\n    left: 5px;\n}\n", ""]);

// exports
